import { render, staticRenderFns } from "./PopupList.vue?vue&type=template&id=2812716e&scoped=true"
import script from "./PopupList.vue?vue&type=script&lang=js"
export * from "./PopupList.vue?vue&type=script&lang=js"
import style0 from "./PopupList.vue?vue&type=style&index=0&id=2812716e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812716e",
  null
  
)

export default component.exports